// eventTypeConfig — the manual "Add Event" type configuration table and its lookup.
//
// Extracted verbatim from `EditTripModal.js` (the `EVENT_TYPE_CONFIG` map used by
// `handleAddManualEvent`) as part of the behavior-preserving refactor (issue #240).
// Each entry maps a manual event type to the id prefix used when generating its id,
// the trip list key it is appended to, and the per-item id field name.
//
// `getEventTypeConfig` mirrors the source's `EVENT_TYPE_CONFIG[newEventType]`
// lookup, returning `undefined` for an unknown type exactly as the source did
// (the source then took its `if (!config)` early-return branch). The
// `console.error` / form-reset side effects of that branch stay in the hook/
// container.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * @typedef {Object} EventTypeConfig
 * @property {string} idPrefix - Prefix used when generating the new item's id.
 * @property {string} listKey - The trip array the new item is appended to.
 * @property {string} idKey - The id field name on the new item.
 */

/** @type {Object<string, EventTypeConfig>} */
export const EVENT_TYPE_CONFIG = {
  flight: { idPrefix: 'flight', listKey: 'flights', idKey: 'flightId' },
  hotel: { idPrefix: 'hotel', listKey: 'hotels', idKey: 'hotelId' },
  car: { idPrefix: 'rental', listKey: 'carRentals', idKey: 'rentalId' },
  dining: { idPrefix: 'dining', listKey: 'diningReservations', idKey: 'reservationId' },
};

/**
 * Looks up the configuration for a manual event type.
 *
 * @param {string} eventType - The manual event type (e.g. `'flight'`, `'dining'`).
 * @returns {EventTypeConfig|undefined} The config, or `undefined` if unknown.
 */
export function getEventTypeConfig(eventType) {
  return EVENT_TYPE_CONFIG[eventType];
}

export default getEventTypeConfig;
